// extracted by mini-css-extract-plugin
module.exports = {"main":"FooterAuth_main__2tMVn","footerLogo":"FooterAuth_footerLogo__ymWmm","cp":"FooterAuth_cp__3ryET","content":"FooterAuth_content__11SdP"};